import moment from "moment";
import React, { Component } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";

import SegmentMessage from "../../components/forms/messages/SegmentMessage.jsx";

import { MODIFIED_AT_TIME_FORMAT } from "../../components/config.js";

import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class SunsetMessage extends Component {
  static propTypes = {
    data: PropTypes.object.isRequired,
    copyKey: PropTypes.string.isRequired,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    copyKey: "image"
  };

  getMessageProps = () => {
    const {
      data: { sunset },
      copyKey,
      copy
    } = this.props;

    const isBefore = moment().isSameOrBefore(sunset.date);

    const titleCopyKey = isBefore ? "title_before" : "title_after";

    const title = `${copy(`${copyKey}.sunset.${titleCopyKey}`)} ${moment(
      sunset.date
    ).format(MODIFIED_AT_TIME_FORMAT)}`;

    return {
      icon: "bed",
      negative: !isBefore,
      warning: isBefore,
      title,
      message: sunset.reason
    };
  };

  // -- RENDER -- //

  render = () => {
    const { data } = this.props;

    if (!data.sunset) return null;

    return <SegmentMessage {...this.getMessageProps()} />;
  };
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(SunsetMessage);
